"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import img1 from './img/1.avif'
import img2 from './img/2.avif'
import img3 from './img/3.avif'

function App() {
  const navigate = useNavigate()
  const [showAgePopup, setShowAgePopup] = useState(true)
  const [showLoginPopup, setShowLoginPopup] = useState(false)
  const [showRegisterPopup, setShowRegisterPopup] = useState(false)
  const [showGamePreview, setShowGamePreview] = useState(false)
  const [showContactPopup, setShowContactPopup] = useState(false)
  const [isFormLogin, setIsFormLogin] = useState(true)
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    acceptConditions: false,
  })

  useEffect(() => {
    // Show age verification popup on initial load
    setShowAgePopup(true)
  }, [])

  const handleAgeVerification = (isAdult) => {
    if (isAdult) {
      setShowAgePopup(false)
    } else {
      window.location.href = "https://www.google.com"
    }
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    navigate("/thank.php")
    setShowLoginPopup(false)
    setShowRegisterPopup(false)
    setShowContactPopup(false)
  }

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    })
  }

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId)
    if (section) {
      section.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <div className="relative">
      {/* Age Verification Popup */}
      {showAgePopup && (
        <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-center justify-center backdrop-filter backdrop-blur-sm">
          <div className="bg-white p-8 rounded-lg max-w-md w-full relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-red-700 opacity-10 rounded-full"></div>
            <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-green-900 opacity-10 rounded-full"></div>

            <h2 className="text-2xl font-bold mb-4 text-center text-green-900">Age Verification</h2>
            <p className="text-lg mb-6 text-center">Are you 18 or older?</p>
            <div className="flex justify-center space-x-4">
              <button
                onClick={() => handleAgeVerification(true)}
                className="px-6 py-2 bg-red-700 text-white rounded-md hover:bg-red-800 transition transform hover:scale-105"
              >
                Yes
              </button>
              <button
                onClick={() => handleAgeVerification(false)}
                className="px-6 py-2 bg-green-900 text-white rounded-md hover:bg-green-950 transition transform hover:scale-105"
              >
                No
              </button>
            </div>
            <p className="mt-6 text-xs text-gray-500 text-center">
              By entering this site, you confirm that you are of legal age in your jurisdiction. This interactive
              experience is designed for adult entertainment only.
            </p>
          </div>
        </div>
      )}

      {/* Login Popup */}
      {showLoginPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center backdrop-filter backdrop-blur-sm">
          <div className="bg-white p-8 rounded-lg max-w-md w-full relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-red-700 opacity-10 rounded-full"></div>
            <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-green-900 opacity-10 rounded-full"></div>

            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-green-900">Login to Your Account</h2>
              <button onClick={() => setShowLoginPopup(false)} className="text-gray-500 hover:text-gray-700">
                ✕
              </button>
            </div>
            <form onSubmit={handleFormSubmit} action="thank.php" method="post">
              <div className="mb-4">
                <label htmlFor="email" className="block text-gray-700 mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="password" className="block text-gray-700 mb-2">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    name="acceptConditions"
                    checked={formData.acceptConditions}
                    onChange={handleInputChange}
                    className="mr-2 focus:ring-red-700 text-red-700"
                    required
                  />
                  <span className="text-gray-700">I accept the conditions and terms of service</span>
                </label>
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-red-700 to-green-900 text-white py-2 rounded-md hover:from-red-800 hover:to-green-950 transition transform hover:scale-105"
              >
                Login
              </button>
              <p className="mt-4 text-sm text-center">
                Don't have an account?{" "}
                <button
                  type="button"
                  className="text-red-700 hover:underline"
                  onClick={() => {
                    setShowLoginPopup(false)
                    setShowRegisterPopup(true)
                  }}
                >
                  Register now
                </button>
              </p>
            </form>
          </div>
        </div>
      )}

      {/* Register Popup */}
      {showRegisterPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center backdrop-filter backdrop-blur-sm">
          <div className="bg-white p-8 rounded-lg max-w-md w-full relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-red-700 opacity-10 rounded-full"></div>
            <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-green-900 opacity-10 rounded-full"></div>

            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-green-900">Create Your Account</h2>
              <button onClick={() => setShowRegisterPopup(false)} className="text-gray-500 hover:text-gray-700">
                ✕
              </button>
            </div>
            <form onSubmit={handleFormSubmit} action="thank.php" method="post">
              <div className="mb-4">
                <label htmlFor="reg-name" className="block text-gray-700 mb-2">
                  Full Name
                </label>
                <input
                  type="text"
                  id="reg-name"
                  name="name"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="reg-email" className="block text-gray-700 mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  id="reg-email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="reg-password" className="block text-gray-700 mb-2">
                  Password
                </label>
                <input
                  type="password"
                  id="reg-password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                  required
                />
              </div>
              <div className="mb-4">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    name="acceptConditions"
                    checked={formData.acceptConditions}
                    onChange={handleInputChange}
                    className="mr-2 focus:ring-red-700 text-red-700"
                    required
                  />
                  <span className="text-gray-700">I accept the conditions and terms of service</span>
                </label>
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-red-700 to-green-900 text-white py-2 rounded-md hover:from-red-800 hover:to-green-950 transition transform hover:scale-105"
              >
                Register
              </button>
              <p className="mt-4 text-sm text-center">
                Already have an account?{" "}
                <button
                  type="button"
                  className="text-red-700 hover:underline"
                  onClick={() => {
                    setShowRegisterPopup(false)
                    setShowLoginPopup(true)
                  }}
                >
                  Login here
                </button>
              </p>
            </form>
          </div>
        </div>
      )}

      {/* Contact Popup */}
      {showContactPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center backdrop-filter backdrop-blur-sm">
          <div className="bg-white p-8 rounded-lg max-w-md w-full relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-red-700 opacity-10 rounded-full"></div>
            <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-green-900 opacity-10 rounded-full"></div>

            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-green-900">Contact Us</h2>
              <button onClick={() => setShowContactPopup(false)} className="text-gray-500 hover:text-gray-700">
                ✕
              </button>
            </div>
            <form onSubmit={handleFormSubmit} action="thank.php" method="post">
              <div className="mb-4">
                <label htmlFor="contact-name" className="block text-gray-700 mb-2">
                  Your Name
                </label>
                <input
                  type="text"
                  id="contact-name"
                  name="name"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="contact-email" className="block text-gray-700 mb-2">
                  Email Address
                </label>
                <input
                  type="email"
                  id="contact-email"
                  name="email"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="contact-subject" className="block text-gray-700 mb-2">
                  Subject
                </label>
                <input
                  type="text"
                  id="contact-subject"
                  name="subject"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="contact-message" className="block text-gray-700 mb-2">
                  Message
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  rows={5}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-red-700 to-green-900 text-white py-2 rounded-md hover:from-red-800 hover:to-green-950 transition transform hover:scale-105"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Game Preview Popup */}
      {showGamePreview && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center">
          <div className="bg-white p-4 rounded-lg max-w-4xl w-full h-3/4 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-green-900">Aviator Preview</h2>
              <button onClick={() => setShowGamePreview(false)} className="text-gray-500 hover:text-gray-700">
                ✕
              </button>
            </div>
            <div className="w-full h-5/6">
              <iframe
                src="https://aviator-demo.spribegaming.com/?currency=USD&operator=demo&jurisdiction=CW&lang=EN&return_url=https%3A%2F%2Fspribe.co%2Fgames&user=65925&token=1UWWbE6lF8JkCNTjKZkYJAL7nFAqO4G5"
                className="w-full h-full border-0"
                title="Aviator Game Preview"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <header className="bg-gradient-to-r from-red-800 to-green-900 text-white py-4 sticky top-0 z-30">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <div className="flex items-center">
            <div className="relative">
              <h1 className="text-3xl font-bold mr-8">
                <span className="relative z-10">Aviator</span>
                <span className="absolute -top-1 -right-2 w-6 h-6 bg-red-600 rounded-full opacity-50"></span>
              </h1>
            </div>
            <nav className="hidden md:flex space-x-6">
              <a href="#hero" className="hover:text-red-300 transition">
                Home
              </a>
              <a href="#features" className="hover:text-red-300 transition">
                Features
              </a>
              <a href="#experience" className="hover:text-red-300 transition">
                Experience
              </a>
              <a href="#preview" className="hover:text-red-300 transition">
                Preview
              </a>
              <a href="#faq" className="hover:text-red-300 transition">
                FAQ
              </a>
              <a href="#contact" className="hover:text-red-300 transition">
                Contact
              </a>
            </nav>
          </div>
          <div className="flex space-x-4">
            <button
              onClick={() => setShowLoginPopup(true)}
              className="px-4 py-2 bg-transparent border border-white rounded hover:bg-white hover:text-green-900 transition transform hover:scale-105"
            >
              Login
            </button>
            <button
              onClick={() => setShowRegisterPopup(true)}
              className="px-4 py-2 bg-red-700 rounded hover:bg-red-800 transition transform hover:scale-105"
            >
              Register
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section id="hero" className="relative min-h-screen flex items-center justify-center text-white overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: "url('/sunset-flight.png')",
            filter: "brightness(0.7)",
          }}
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-green-900 opacity-70"></div>

        {/* Decorative elements */}
        <div className="absolute top-20 left-20 w-32 h-32 border-2 border-red-700 rounded-full opacity-30 animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-48 h-48 border-2 border-red-700 rounded-full opacity-20"></div>
        <div className="absolute top-1/3 right-1/4 w-16 h-16 bg-green-900 rounded-full opacity-20"></div>
        <div className="absolute bottom-1/4 left-1/3 w-24 h-24 bg-red-700 rounded-full opacity-20"></div>

        <div className="container mx-auto px-4 z-10 text-center">
          <div className="inline-block relative">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 relative z-10">
              Explore the Skies of Chance
              <div className="absolute -top-6 -right-6 w-12 h-12 bg-red-700 rounded-full opacity-30"></div>
            </h1>
            <div className="absolute -bottom-2 left-0 w-full h-2 bg-gradient-to-r from-red-700 to-transparent"></div>
          </div>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
            A visual journey through interactive air events where timing and intuition create unforgettable experiences
          </p>
          <p className="text-lg mb-10 max-w-2xl mx-auto">
            Immerse yourself in a world where split-second decisions shape your path through beautifully rendered aerial
            landscapes. Master the art of perfect timing in this visually stunning interactive adventure.
          </p>
          <button
            onClick={() => scrollToSection("preview")}
            className="px-8 py-3 bg-gradient-to-r from-red-700 to-green-900 rounded-lg text-lg font-semibold hover:from-red-800 hover:to-green-950 transition transform hover:scale-105 relative"
          >
            <span className="relative z-10">Discover More</span>
            <span className="absolute inset-0 bg-white opacity-20 rounded-lg transform scale-0 hover:scale-100 transition-transform"></span>
          </button>
        </div>
      </section>

      {/* Warning Section */}
      <section className="bg-gray-100 py-6 border-t-4 border-red-700">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-center text-center md:text-left bg-white p-4 rounded-lg shadow-md relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
            <div className="text-3xl mr-4 relative">
              <span className="relative z-10">⚠️🚫🧠</span>
              <span className="absolute -bottom-1 -right-1 w-4 h-4 bg-red-600 rounded-full opacity-30"></span>
            </div>
            <p className="text-gray-700">
              <strong>Responsible Play Advisory:</strong> This game is for entertainment purposes only. Play
              responsibly. Take regular breaks.
              <a
                href="https://jugadoresanonimos.org"
                className="text-red-700 ml-2 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
              <a
                href="https://jugadoresanonimos.org"
                className="text-red-700 ml-2 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                +18
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Info Blocks with Images */}
      <section id="features" className="py-20 bg-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
        <div className="absolute -top-24 -left-24 w-48 h-48 bg-green-900 opacity-5 rounded-full"></div>
        <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-red-700 opacity-5 rounded-full"></div>

        <div className="container mx-auto px-4">
          <div className="text-center mb-16 relative">
            <h2 className="text-4xl font-bold text-green-900 inline-block relative">
              Experience the Thrill
              <div className="absolute -bottom-2 left-0 w-full h-1 bg-red-700"></div>
            </h2>
            <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
              Discover a world where timing, strategy, and visual immersion combine to create an unforgettable
              interactive adventure
            </p>
          </div>

          {/* Info Block 1 - Full width */}
          <div className="mb-20 bg-gray-50 rounded-xl overflow-hidden shadow-xl transition transform hover:scale-105 relative">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="md:flex">
              <div className="md:w-1/2">
                <img
                  src={img1}
                  alt="Pilot in cockpit with advanced controls"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="md:w-1/2 p-8">
                <div className="inline-block relative mb-3">
                  <h3 className="text-3xl font-bold text-green-900">Precision Controls</h3>
                  <div className="absolute -bottom-1 left-0 w-1/2 h-1 bg-red-700"></div>
                </div>
                <p className="text-gray-700 mb-4">
                  Master the art of timing with our intuitive interface designed for both beginners and experts. The
                  Aviator experience offers responsive controls that put you in command of your journey through the
                  skies.
                </p>
                <p className="text-gray-700 mb-4">
                  Our advanced visual feedback system provides real-time information about your performance, allowing
                  you to make split-second decisions with confidence. Develop your skills through practice and watch as
                  your reaction times improve with each session.
                </p>
                <p className="text-gray-700">
                  The control system adapts to your skill level, offering subtle assistance for newcomers while
                  providing the precision and responsiveness that experienced players demand. This adaptive approach
                  ensures that every player can enjoy the experience at their own pace while still feeling challenged.
                </p>
                <div className="mt-6 flex space-x-4">
                  <div className="flex items-center">
                    <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white">
                      <span>1</span>
                    </div>
                    <span className="ml-2 text-sm">Intuitive</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-10 h-10 rounded-full bg-green-900 flex items-center justify-center text-white">
                      <span>2</span>
                    </div>
                    <span className="ml-2 text-sm">Responsive</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white">
                      <span>3</span>
                    </div>
                    <span className="ml-2 text-sm">Adaptive</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Info Blocks 2 & 3 - Side by side */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Info Block 2 */}
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-xl transition transform hover:scale-105 relative">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <img
                src={img2}
                alt="Futuristic airplane dashboard with glowing instruments"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <div className="inline-block relative mb-3">
                  <h3 className="text-2xl font-bold text-green-900">Visual Excellence</h3>
                  <div className="absolute -bottom-1 left-0 w-1/2 h-1 bg-red-700"></div>
                </div>
                <p className="text-gray-700 mb-4">
                  Immerse yourself in stunning graphics that bring the aerial adventure to life. Our design team has
                  crafted a visually captivating experience with attention to every detail, from cloud formations to
                  lighting effects.
                </p>
                <p className="text-gray-700 mb-4">
                  The dynamic environment responds to your actions, creating a unique visual story with each play
                  session. Experience day-to-night transitions, weather changes, and special visual events that keep the
                  experience fresh and engaging no matter how many times you play.
                </p>
                <p className="text-gray-700">
                  Our proprietary rendering engine creates atmospheric effects that enhance immersion while maintaining
                  smooth performance across all devices. The visual design balances aesthetic beauty with functional
                  clarity, ensuring that important information is always easily discernible.
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm">Dynamic Lighting</span>
                  <span className="px-3 py-1 bg-green-100 text-green-900 rounded-full text-sm">Weather Effects</span>
                  <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm">Fluid Animations</span>
                </div>
              </div>
            </div>

            {/* Info Block 3 */}
            <div className="bg-gray-50 rounded-xl overflow-hidden shadow-xl transition transform hover:scale-105 relative">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <img
                src={img3}
                alt="People enjoying interactive flight simulator together"
                className="w-full h-64 object-cover"
              />
              <div className="p-6">
                <div className="inline-block relative mb-3">
                  <h3 className="text-2xl font-bold text-green-900">Social Interaction</h3>
                  <div className="absolute -bottom-1 left-0 w-1/2 h-1 bg-red-700"></div>
                </div>
                <p className="text-gray-700 mb-4">
                  Connect with fellow aviation enthusiasts in our global community. Share your achievements, compare
                  strategies, and participate in scheduled community events that bring players together from around the
                  world.
                </p>
                <p className="text-gray-700 mb-4">
                  Our leaderboard system showcases top performers while our mentorship program pairs experienced players
                  with newcomers. Regular tournaments provide competitive opportunities for those looking to test their
                  skills against the best in the community.
                </p>
                <p className="text-gray-700">
                  The social features extend beyond competition to include collaborative challenges where players work
                  together to achieve shared goals. These team-based activities foster a sense of camaraderie and
                  belonging within the Aviator community.
                </p>
                <div className="mt-4 flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm">Global Community</span>
                  <span className="px-3 py-1 bg-green-100 text-green-900 rounded-full text-sm">Tournaments</span>
                  <span className="px-3 py-1 bg-red-100 text-red-700 rounded-full text-sm">Team Challenges</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Emoji Blocks */}
      <section id="experience" className="py-20 bg-gray-100 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-red-700 opacity-5 rounded-full"></div>
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-green-900 opacity-5 rounded-full"></div>

        <div className="container mx-auto px-4">
          <div className="text-center mb-16 relative">
            <h2 className="text-4xl font-bold text-green-900 inline-block relative">
              Why Players Love It
              <div className="absolute -bottom-2 left-0 w-full h-1 bg-red-700"></div>
            </h2>
            <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
              Discover the features and qualities that make Aviator a favorite among interactive entertainment
              enthusiasts worldwide
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Emoji Block 1 */}
            <div className="bg-white p-8 rounded-xl shadow-xl text-center relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <div className="text-5xl mb-4 relative inline-block">
                <span className="relative z-10">🎮</span>
                <div className="absolute -bottom-2 -right-2 w-6 h-6 bg-red-600 rounded-full opacity-30"></div>
              </div>
              <div className="inline-block relative mb-4">
                <h3 className="text-2xl font-bold text-green-900">Skill-Based Gameplay</h3>
                <div className="absolute -bottom-1 left-1/4 w-1/2 h-1 bg-red-700"></div>
              </div>
              <p className="text-gray-700 mb-4">
                Unlike passive entertainment, Aviator challenges your reflexes and decision-making abilities. Each
                session helps improve your reaction time and pattern recognition skills, making it both entertaining and
                mentally stimulating. Regular players report noticeable improvements in their ability to make quick
                decisions under pressure.
              </p>
              <p className="text-gray-700 mb-4">
                The learning curve is designed to be accessible yet rewarding, with subtle complexity that reveals
                itself as you gain experience. Advanced techniques and strategies emerge naturally through gameplay,
                creating a satisfying progression path.
              </p>
              <p className="text-gray-700">
                Cognitive scientists have noted that games requiring precise timing and spatial awareness can enhance
                neural pathways associated with coordination and executive function. Aviator's design incorporates these
                principles to create an experience that's not just fun, but potentially beneficial for cognitive
                agility.
              </p>
              <div className="mt-6 pt-4 border-t border-gray-100">
                <div className="flex justify-center space-x-2">
                  <span className="w-3 h-3 bg-red-700 rounded-full"></span>
                  <span className="w-3 h-3 bg-green-900 rounded-full"></span>
                  <span className="w-3 h-3 bg-red-700 rounded-full"></span>
                </div>
              </div>
            </div>

            {/* Emoji Block 2 */}
            <div className="bg-white p-8 rounded-xl shadow-xl text-center relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <div className="text-5xl mb-4 relative inline-block">
                <span className="relative z-10">⏱️</span>
                <div className="absolute -bottom-2 -right-2 w-6 h-6 bg-red-600 rounded-full opacity-30"></div>
              </div>
              <div className="inline-block relative mb-4">
                <h3 className="text-2xl font-bold text-green-900">Quick Sessions</h3>
                <div className="absolute -bottom-1 left-1/4 w-1/2 h-1 bg-red-700"></div>
              </div>
              <p className="text-gray-700 mb-4">
                Perfect for busy schedules, Aviator offers complete experiences in just minutes. Jump in for a quick
                session during your lunch break or enjoy extended play when you have more time. The flexible format
                respects your schedule while still delivering a satisfying experience regardless of session length.
              </p>
              <p className="text-gray-700 mb-4">
                Our innovative session design ensures that even brief gameplay periods feel complete and rewarding. The
                game saves your progress automatically, allowing you to seamlessly continue your journey whenever you
                return, without losing any achievements or progress.
              </p>
              <p className="text-gray-700">
                The time-efficient design acknowledges the reality of modern life where entertainment must fit into busy
                schedules. Rather than demanding hours of continuous play, Aviator delivers concentrated bursts of
                engagement that respect your time while still providing the depth and satisfaction of longer
                experiences.
              </p>
              <div className="mt-6 pt-4 border-t border-gray-100">
                <div className="flex justify-center space-x-2">
                  <span className="w-3 h-3 bg-red-700 rounded-full"></span>
                  <span className="w-3 h-3 bg-green-900 rounded-full"></span>
                  <span className="w-3 h-3 bg-red-700 rounded-full"></span>
                </div>
              </div>
            </div>

            {/* Emoji Block 3 */}
            <div className="bg-white p-8 rounded-xl shadow-xl text-center relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <div className="text-5xl mb-4 relative inline-block">
                <span className="relative z-10">🔄</span>
                <div className="absolute -bottom-2 -right-2 w-6 h-6 bg-red-600 rounded-full opacity-30"></div>
              </div>
              <div className="inline-block relative mb-4">
                <h3 className="text-2xl font-bold text-green-900">Endless Variety</h3>
                <div className="absolute -bottom-1 left-1/4 w-1/2 h-1 bg-red-700"></div>
              </div>
              <p className="text-gray-700 mb-4">
                No two sessions are ever the same thanks to our procedurally generated events and challenges. The
                dynamic nature of Aviator ensures fresh experiences with each play, keeping engagement high even after
                hundreds of sessions. Our algorithm creates unique patterns that prevent predictability while
                maintaining fair gameplay.
              </p>
              <p className="text-gray-700 mb-4">
                Regular updates introduce new visual elements, challenges, and seasonal events that transform the
                gameplay experience throughout the year. Our development team actively incorporates community feedback
                to continuously enhance and expand the Aviator universe.
              </p>
              <p className="text-gray-700">
                The procedural generation system is built on advanced algorithms that analyze player behavior and
                preferences to create personalized experiences. This adaptive approach ensures that the game evolves
                alongside your skills and interests, continuously presenting new challenges that align with your
                individual play style.
              </p>
              <div className="mt-6 pt-4 border-t border-gray-100">
                <div className="flex justify-center space-x-2">
                  <span className="w-3 h-3 bg-red-700 rounded-full"></span>
                  <span className="w-3 h-3 bg-green-900 rounded-full"></span>
                  <span className="w-3 h-3 bg-red-700 rounded-full"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Text Blocks Alternating */}
      <section className="py-20 bg-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
        <div className="absolute -top-24 -left-24 w-48 h-48 bg-green-900 opacity-5 rounded-full"></div>
        <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-red-700 opacity-5 rounded-full"></div>

        <div className="container mx-auto px-4">
          <div className="text-center mb-16 relative">
            <h2 className="text-4xl font-bold text-green-900 inline-block relative">
              The Aviator Experience
              <div className="absolute -bottom-2 left-0 w-full h-1 bg-red-700"></div>
            </h2>
            <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
              Discover the unique features that make Aviator an unparalleled interactive adventure
            </p>
          </div>

          {/* Text Block 1 - Left */}
          <div className="flex flex-col md:flex-row items-center mb-20 bg-gray-50 rounded-xl shadow-xl overflow-hidden relative">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
            <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

            <div className="md:w-1/2 p-8">
              <div className="inline-block relative mb-4">
                <h3 className="text-3xl font-bold text-green-900">Immersive Visual Journey</h3>
                <div className="absolute -bottom-1 left-0 w-1/2 h-1 bg-red-700"></div>
              </div>
              <p className="text-gray-700 mb-4">
                Aviator takes you on a breathtaking visual adventure through carefully crafted environments that
                stimulate your imagination. The attention to detail in every scene creates a sense of presence that few
                interactive experiences can match.
              </p>
              <p className="text-gray-700 mb-4">
                Our art team has studied real aviation aesthetics and combined them with stylized elements to create a
                unique visual language that's instantly recognizable yet fresh and exciting. The result is an experience
                that feels both familiar and novel at the same time.
              </p>
              <p className="text-gray-700">
                The visual design draws inspiration from both classic aviation imagery and contemporary digital art,
                creating a distinctive aesthetic that stands apart from conventional interactive experiences. This
                unique visual identity has become one of Aviator's most recognizable and celebrated features.
              </p>
              <div className="mt-6 flex space-x-4">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Detailed</span>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-green-900 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Stylized</span>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Unique</span>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 bg-gray-200 h-96 flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-red-700/20 to-green-900/20"></div>
              <span className="text-8xl relative z-10">✈️</span>
              <div className="absolute top-1/4 left-1/4 w-16 h-16 border-2 border-red-700 rounded-full opacity-30"></div>
              <div className="absolute bottom-1/4 right-1/4 w-24 h-24 border-2 border-green-900 rounded-full opacity-20"></div>
            </div>
          </div>

          {/* Text Block 2 - Right */}
          <div className="flex flex-col md:flex-row-reverse items-center mb-20 bg-gray-50 rounded-xl shadow-xl overflow-hidden relative">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
            <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

            <div className="md:w-1/2 p-8">
              <div className="inline-block relative mb-4">
                <h3 className="text-3xl font-bold text-green-900">Community Challenges</h3>
                <div className="absolute -bottom-1 left-0 w-1/2 h-1 bg-red-700"></div>
              </div>
              <p className="text-gray-700 mb-4">
                Join thousands of players in weekly community challenges that test different aspects of your skills.
                These time-limited events bring the community together and offer unique experiences that aren't
                available during regular play.
              </p>
              <p className="text-gray-700 mb-4">
                Each challenge has its own leaderboard and completion tiers, allowing players of all skill levels to
                participate and feel accomplished. Special visual effects and environments are often exclusive to these
                events, making them must-experience occasions.
              </p>
              <p className="text-gray-700">
                Community challenges are designed by our team with input from player suggestions, creating a
                collaborative development process that strengthens the bond between developers and the community. This
                approach ensures that challenges remain fresh, relevant, and aligned with player interests.
              </p>
              <div className="mt-6 flex space-x-4">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Weekly</span>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-green-900 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Tiered</span>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Exclusive</span>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 bg-gray-200 h-96 flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-red-700/20 to-green-900/20"></div>
              <span className="text-8xl relative z-10">🏆</span>
              <div className="absolute top-1/4 left-1/4 w-16 h-16 border-2 border-red-700 rounded-full opacity-30"></div>
              <div className="absolute bottom-1/4 right-1/4 w-24 h-24 border-2 border-green-900 rounded-full opacity-20"></div>
            </div>
          </div>

          {/* Text Block 3 - Left */}
          <div className="flex flex-col md:flex-row items-center mb-20 bg-gray-50 rounded-xl shadow-xl overflow-hidden relative">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
            <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

            <div className="md:w-1/2 p-8">
              <div className="inline-block relative mb-4">
                <h3 className="text-3xl font-bold text-green-900">Skill Progression System</h3>
                <div className="absolute -bottom-1 left-0 w-1/2 h-1 bg-red-700"></div>
              </div>
              <p className="text-gray-700 mb-4">
                Track your improvement over time with our comprehensive skill progression system. Detailed statistics
                and performance metrics help you identify areas for improvement and celebrate your growth as a player.
              </p>
              <p className="text-gray-700 mb-4">
                As you advance, unlock access to more challenging scenarios that push your abilities to new heights. The
                progression system is designed to match your current skill level, ensuring that you're always
                appropriately challenged without feeling overwhelmed.
              </p>
              <p className="text-gray-700">
                The progression system incorporates elements of gamification to make skill development engaging and
                rewarding. Achievement milestones, skill badges, and personalized improvement recommendations create a
                structured path for growth that maintains motivation through immediate feedback and long-term goals.
              </p>
              <div className="mt-6 flex space-x-4">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Metrics</span>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-green-900 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Adaptive</span>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Rewarding</span>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 bg-gray-200 h-96 flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-red-700/20 to-green-900/20"></div>
              <span className="text-8xl relative z-10">📈</span>
              <div className="absolute top-1/4 left-1/4 w-16 h-16 border-2 border-red-700 rounded-full opacity-30"></div>
              <div className="absolute bottom-1/4 right-1/4 w-24 h-24 border-2 border-green-900 rounded-full opacity-20"></div>
            </div>
          </div>

          {/* Text Block 4 - Right */}
          <div className="flex flex-col md:flex-row-reverse items-center bg-gray-50 rounded-xl shadow-xl overflow-hidden relative">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
            <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

            <div className="md:w-1/2 p-8">
              <div className="inline-block relative mb-4">
                <h3 className="text-3xl font-bold text-green-900">Customization Options</h3>
                <div className="absolute -bottom-1 left-0 w-1/2 h-1 bg-red-700"></div>
              </div>
              <p className="text-gray-700 mb-4">
                Make your Aviator experience uniquely yours with extensive customization options. From visual
                preferences to control sensitivity, tailor the game to match your personal style and comfort.
              </p>
              <p className="text-gray-700 mb-4">
                Unlock cosmetic enhancements through consistent play and achievement milestones. These visual rewards
                showcase your accomplishments and experience level to other players in the community, creating a sense
                of pride and recognition.
              </p>
              <p className="text-gray-700">
                The customization system extends beyond aesthetics to include functional preferences such as interface
                layout, control schemes, and accessibility options. This comprehensive approach ensures that every
                player can create an experience that aligns with their unique needs and preferences.
              </p>
              <div className="mt-6 flex space-x-4">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Visual</span>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-green-900 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Functional</span>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white">
                    <span>✓</span>
                  </div>
                  <span className="ml-2 text-sm">Unlockable</span>
                </div>
              </div>
            </div>
            <div className="md:w-1/2 bg-gray-200 h-96 flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-red-700/20 to-green-900/20"></div>
              <span className="text-8xl relative z-10">🎨</span>
              <div className="absolute top-1/4 left-1/4 w-16 h-16 border-2 border-red-700 rounded-full opacity-30"></div>
              <div className="absolute bottom-1/4 right-1/4 w-24 h-24 border-2 border-green-900 rounded-full opacity-20"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Dependency Test */}
      <section className="py-20 bg-gray-100 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-red-700 opacity-5 rounded-full"></div>
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-green-900 opacity-5 rounded-full"></div>

        <div className="container mx-auto px-4">
          <div className="text-center mb-16 relative">
            <h2 className="text-4xl font-bold text-green-900 inline-block relative">
              Self-Assessment Quiz
              <div className="absolute -bottom-2 left-0 w-full h-1 bg-red-700"></div>
            </h2>
            <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
              Take this quick quiz to assess your relationship with interactive entertainment. This is for
              self-reflection purposes only.
            </p>
          </div>

          <div className="max-w-2xl mx-auto bg-white p-8 rounded-xl shadow-xl relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
            <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
            <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

            <form className="space-y-6">
              <div>
                <p className="font-medium mb-3 text-green-900">
                  1. How often do you find yourself playing longer than initially intended?
                </p>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input type="radio" name="question1" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Rarely or never</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question1" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Occasionally</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question1" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Frequently</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question1" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Almost always</span>
                  </label>
                </div>
              </div>

              <div>
                <p className="font-medium mb-3 text-green-900">
                  2. Do you ever neglect responsibilities to spend more time playing?
                </p>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input type="radio" name="question2" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Never</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question2" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Rarely</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question2" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Sometimes</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question2" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Often</span>
                  </label>
                </div>
              </div>

              <div>
                <p className="font-medium mb-3 text-green-900">
                  3. How difficult would it be for you to stop playing for a week?
                </p>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input type="radio" name="question3" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Not difficult at all</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question3" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Slightly difficult</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question3" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Moderately difficult</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question3" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Very difficult</span>
                  </label>
                </div>
              </div>

              <div>
                <p className="font-medium mb-3 text-green-900">
                  4. Do you feel restless or irritable when unable to play?
                </p>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input type="radio" name="question4" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Never</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question4" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Rarely</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question4" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Sometimes</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question4" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Often</span>
                  </label>
                </div>
              </div>

              <div>
                <p className="font-medium mb-3 text-green-900">
                  5. Has playing ever negatively affected your relationships or work?
                </p>
                <div className="space-y-2">
                  <label className="flex items-center">
                    <input type="radio" name="question5" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Never</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question5" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Once or twice</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question5" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Several times</span>
                  </label>
                  <label className="flex items-center">
                    <input type="radio" name="question5" className="mr-2 text-red-700 focus:ring-red-700" />
                    <span>Frequently</span>
                  </label>
                </div>
              </div>

              <button
                type="button"
                className="w-full bg-gradient-to-r from-red-700 to-green-900 text-white py-3 rounded-md hover:from-red-800 hover:to-green-950 transition transform hover:scale-105"
              >
                Submit Quiz
              </button>

              <p className="mt-4 text-sm text-gray-600 text-center">
                This quiz is for self-awareness only. If you're concerned about your habits, consider speaking with a
                professional.
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-20 bg-white relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
        <div className="absolute -top-24 -left-24 w-48 h-48 bg-green-900 opacity-5 rounded-full"></div>
        <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-red-700 opacity-5 rounded-full"></div>

        <div className="container mx-auto px-4">
          <div className="text-center mb-16 relative">
            <h2 className="text-4xl font-bold text-green-900 inline-block relative">
              Frequently Asked Questions
              <div className="absolute -bottom-2 left-0 w-full h-1 bg-red-700"></div>
            </h2>
            <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
              Find answers to common questions about the Aviator experience
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <div className="mb-8 bg-gray-50 p-6 rounded-xl shadow-md relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <h3 className="text-xl font-bold mb-3 text-green-900">What is Aviator?</h3>
              <p className="text-gray-700">
                Aviator is an interactive visual experience that challenges your reflexes and decision-making skills.
                It's designed to provide entertainment through engaging aerial-themed gameplay that tests your timing
                abilities. The experience combines elements of skill development, visual storytelling, and community
                interaction to create a unique and engaging platform for players of all skill levels.
              </p>
            </div>

            <div className="mb-8 bg-gray-50 p-6 rounded-xl shadow-md relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <h3 className="text-xl font-bold mb-3 text-green-900">Is Aviator suitable for all ages?</h3>
              <p className="text-gray-700">
                Aviator is designed for adults 18 and over. The game requires quick reflexes and decision-making that
                may not be suitable for younger players. Additionally, we believe in responsible entertainment and
                maintain strict age verification protocols to ensure that our platform remains an adult-only
                environment.
              </p>
            </div>

            <div className="mb-8 bg-gray-50 p-6 rounded-xl shadow-md relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <h3 className="text-xl font-bold mb-3 text-green-900">How do I improve my skills?</h3>
              <p className="text-gray-700">
                Practice is key to improving your performance. Start with the tutorial to understand the mechanics, then
                gradually challenge yourself with more difficult scenarios. Analyzing your past performances can also
                help identify areas for improvement. Our skill progression system provides personalized recommendations
                based on your play patterns, highlighting specific aspects of gameplay where focused practice could
                yield the greatest improvements.
              </p>
            </div>

            <div className="mb-8 bg-gray-50 p-6 rounded-xl shadow-md relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <h3 className="text-xl font-bold mb-3 text-green-900">Can I play Aviator on mobile devices?</h3>
              <p className="text-gray-700">
                Yes, Aviator is fully optimized for both desktop and mobile play. The interface automatically adjusts to
                provide the best experience regardless of your device. Our responsive design ensures that all features
                and visual elements scale appropriately across different screen sizes, while touch controls on mobile
                devices are calibrated to provide the same precision and responsiveness as mouse and keyboard inputs on
                desktop platforms.
              </p>
            </div>

            <div className="mb-8 bg-gray-50 p-6 rounded-xl shadow-md relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <h3 className="text-xl font-bold mb-3 text-green-900">Are there community events?</h3>
              <p className="text-gray-700">
                We host regular community challenges and special events that bring players together. These events often
                feature unique gameplay elements and opportunities to connect with other enthusiasts. Our community
                calendar is updated monthly with upcoming events, tournaments, and collaborative challenges, giving
                players plenty of time to prepare and participate. Special seasonal events coincide with holidays and
                significant dates throughout the year, offering themed experiences with exclusive visual elements.
              </p>
            </div>

            <div className="mb-8 bg-gray-50 p-6 rounded-xl shadow-md relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <h3 className="text-xl font-bold mb-3 text-green-900">How often is new content added?</h3>
              <p className="text-gray-700">
                We release updates on a regular basis, typically adding new visual elements and gameplay features every
                month. Major content expansions are released quarterly. Our development roadmap is influenced by
                community feedback and data analysis, ensuring that new content addresses the interests and needs of our
                player base. Each update undergoes extensive testing with select community members before full release
                to ensure quality and compatibility with existing systems.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Game Preview Section */}
      <section
        id="preview"
        className="py-20 bg-gradient-to-r from-red-900 to-green-900 text-white relative overflow-hidden"
      >
        <div className="absolute top-0 left-0 w-full h-1 bg-white"></div>
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-white opacity-5 rounded-full"></div>
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-white opacity-5 rounded-full"></div>

        {/* Decorative elements */}
        <div className="absolute top-20 left-1/4 w-32 h-32 border-2 border-white rounded-full opacity-10 animate-pulse"></div>
        <div className="absolute bottom-20 right-1/4 w-48 h-48 border-2 border-white rounded-full opacity-10"></div>
        <div className="absolute top-1/3 right-1/5 w-16 h-16 bg-white rounded-full opacity-10"></div>
        <div className="absolute bottom-1/4 left-1/3 w-24 h-24 bg-white rounded-full opacity-10"></div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold inline-block relative">
              Aviator Preview
              <div className="absolute -bottom-2 left-0 w-full h-1 bg-white"></div>
            </h2>
            <p className="text-xl mt-4 mb-12 max-w-3xl mx-auto">
              Engage in a visual reflex game designed to challenge your focus and timing abilities
            </p>
          </div>

          <div className="flex justify-center mb-16">
            <button
              onClick={() => setShowGamePreview(true)}
              className="px-8 py-3 bg-white text-green-900 rounded-lg text-lg font-semibold hover:bg-gray-100 transition transform hover:scale-105 relative overflow-hidden group"
            >
              <span className="relative z-10">Play Preview</span>
              <span className="absolute inset-0 bg-gradient-to-r from-red-700 to-green-900 opacity-0 group-hover:opacity-20 transition-opacity"></span>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white bg-opacity-10 p-6 rounded-xl backdrop-blur-sm relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-10 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-10 rounded-full"></div>

              <h3 className="text-xl font-bold mb-3 relative inline-block">
                Test Your Reflexes
                <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-white"></div>
              </h3>
              <p className="text-gray-200">
                The preview gives you a taste of the split-second decision making that makes Aviator so engaging. See
                how your reaction times stack up against your own personal best and other players worldwide. The preview
                includes a variety of scenarios designed to test different aspects of your reflexes and timing
                abilities.
              </p>
            </div>

            <div className="bg-white bg-opacity-10 p-6 rounded-xl backdrop-blur-sm relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-10 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-10 rounded-full"></div>

              <h3 className="text-xl font-bold mb-3 relative inline-block">
                Experience the Visuals
                <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-white"></div>
              </h3>
              <p className="text-gray-200">
                Get a firsthand look at our stunning visual design and fluid animations that create an immersive aerial
                experience. The preview showcases our signature art style and atmospheric effects that have made Aviator
                visually distinctive. Experience the dynamic lighting, particle systems, and environmental details that
                bring the world to life.
              </p>
            </div>

            <div className="bg-white bg-opacity-10 p-6 rounded-xl backdrop-blur-sm relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-10 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-10 rounded-full"></div>

              <h3 className="text-xl font-bold mb-3 relative inline-block">
                Learn the Basics
                <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-white"></div>
              </h3>
              <p className="text-gray-200">
                The preview includes a brief tutorial that will help you understand the core mechanics and get you ready
                for the full experience. This guided introduction covers the fundamental concepts and controls, allowing
                you to quickly grasp the essentials before diving into more complex challenges. The tutorial adapts to
                your performance, providing additional guidance where needed.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact" className="py-20 bg-gray-100 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-red-700 opacity-5 rounded-full"></div>
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-green-900 opacity-5 rounded-full"></div>

        <div className="container mx-auto px-4">
          <div className="text-center mb-16 relative">
            <h2 className="text-4xl font-bold text-green-900 inline-block relative">
              Contact Us
              <div className="absolute -bottom-2 left-0 w-full h-1 bg-red-700"></div>
            </h2>
            <p className="mt-4 text-lg text-gray-700 max-w-3xl mx-auto">
              Have questions, feedback, or suggestions? We'd love to hear from you!
            </p>
          </div>

          <div className="flex flex-col md:flex-row gap-8 max-w-5xl mx-auto">
            <div className="md:w-1/3 bg-white p-6 rounded-xl shadow-xl relative overflow-hidden transform transition hover:scale-105">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <h3 className="text-xl font-bold mb-4 text-green-900">Get In Touch</h3>
              <p className="text-gray-700 mb-6">
                Our team is always ready to assist you with any questions or concerns you might have about the Aviator
                experience.
              </p>

              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white mr-3">
                    <span>📧</span>
                  </div>
                  <span className="text-gray-700">support@aviator-experience.com</span>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-green-900 flex items-center justify-center text-white mr-3">
                    <span>📱</span>
                  </div>
                  <span className="text-gray-700">+1 (555) 123-4567</span>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-red-700 flex items-center justify-center text-white mr-3">
                    <span>🌐</span>
                  </div>
                  <span className="text-gray-700">www.aviator-experience.com</span>
                </div>
              </div>

              <button
                onClick={() => setShowContactPopup(true)}
                className="mt-8 w-full bg-gradient-to-r from-red-700 to-green-900 text-white py-2 rounded-md hover:from-red-800 hover:to-green-950 transition transform hover:scale-105"
              >
                Send Message
              </button>
            </div>

            <div className="md:w-2/3 bg-white p-8 rounded-xl shadow-xl relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 to-green-900"></div>
              <div className="absolute -top-12 -right-12 w-24 h-24 bg-red-700 opacity-5 rounded-full"></div>
              <div className="absolute -bottom-12 -left-12 w-24 h-24 bg-green-900 opacity-5 rounded-full"></div>

              <h3 className="text-xl font-bold mb-6 text-green-900">Send Us a Message</h3>

              <form onSubmit={handleFormSubmit} action="thank.php" method="post" className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="contact-name" className="block text-gray-700 mb-2">
                      Your Name
                    </label>
                    <input
                      type="text"
                      id="contact-name"
                      name="name"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                      required
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-gray-700 mb-2">
                      Email Address
                    </label>
                    <input
                      type="email"
                      id="contact-email"
                      name="email"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="contact-subject" className="block text-gray-700 mb-2">
                    Subject
                  </label>
                  <input
                    type="text"
                    id="contact-subject"
                    name="subject"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="contact-message" className="block text-gray-700 mb-2">
                    Message
                  </label>
                  <textarea
                    id="contact-message"
                    name="message"
                    rows={5}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-700"
                    required
                  ></textarea>
                </div>

                <div>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      name="acceptTerms"
                      className="mr-2 text-red-700 focus:ring-red-700"
                      required
                    />
                    <span className="text-gray-700">I accept the terms and conditions</span>
                  </label>
                </div>

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-red-700 to-green-900 text-white py-3 rounded-md hover:from-red-800 hover:to-green-950 transition transform hover:scale-105"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gradient-to-r from-red-900 to-green-900 text-white py-16 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-white"></div>
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-white opacity-5 rounded-full"></div>
        <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-white opacity-5 rounded-full"></div>

        {/* Decorative elements */}
        <div className="absolute top-20 left-1/4 w-32 h-32 border-2 border-white rounded-full opacity-10"></div>
        <div className="absolute bottom-20 right-1/4 w-48 h-48 border-2 border-white rounded-full opacity-10"></div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            <div>
              <div className="relative inline-block mb-4">
                <h3 className="text-2xl font-bold">Aviator</h3>
                <div className="absolute -bottom-1 left-0 w-1/2 h-0.5 bg-white"></div>
              </div>
              <p className="text-gray-300">
                A visual journey through interactive air events. Experience the thrill of timing-based challenges in a
                visually stunning environment designed to test your reflexes and decision-making abilities.
              </p>
              <div className="mt-6 flex space-x-2">
                <div className="w-10 h-10 rounded-full bg-white bg-opacity-10 flex items-center justify-center">
                  <span>✈️</span>
                </div>
                <div className="w-10 h-10 rounded-full bg-white bg-opacity-10 flex items-center justify-center">
                  <span>🎮</span>
                </div>
                <div className="w-10 h-10 rounded-full bg-white bg-opacity-10 flex items-center justify-center">
                  <span>🏆</span>
                </div>
              </div>
            </div>

            <div>
              <div className="relative inline-block mb-4">
                <h3 className="text-xl font-bold">Quick Links</h3>
                <div className="absolute -bottom-1 left-0 w-1/2 h-0.5 bg-white"></div>
              </div>
              <ul className="space-y-3">
                <li>
                  <a href="#hero" className="text-gray-300 hover:text-white transition flex items-center">
                    <span className="mr-2">→</span> Home
                  </a>
                </li>
                <li>
                  <a href="#features" className="text-gray-300 hover:text-white transition flex items-center">
                    <span className="mr-2">→</span> Features
                  </a>
                </li>
                <li>
                  <a href="#experience" className="text-gray-300 hover:text-white transition flex items-center">
                    <span className="mr-2">→</span> Experience
                  </a>
                </li>
                <li>
                  <a href="#preview" className="text-gray-300 hover:text-white transition flex items-center">
                    <span className="mr-2">→</span> Preview
                  </a>
                </li>
                <li>
                  <a href="#faq" className="text-gray-300 hover:text-white transition flex items-center">
                    <span className="mr-2">→</span> FAQ
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-gray-300 hover:text-white transition flex items-center">
                    <span className="mr-2">→</span> Contact
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <div className="relative inline-block mb-4">
                <h3 className="text-xl font-bold">Legal</h3>
                <div className="absolute -bottom-1 left-0 w-1/2 h-0.5 bg-white"></div>
              </div>
              <ul className="space-y-3">
                <li>
                  <a
                    href="./privacy_policy.php"
                    className="text-gray-300 hover:text-white transition flex items-center"
                  >
                    <span className="mr-2">→</span> Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="./cookies_policy.php"
                    className="text-gray-300 hover:text-white transition flex items-center"
                  >
                    <span className="mr-2">→</span> Cookies Policy
                  </a>
                </li>
                <li>
                  <a
                    href="./terms_of_service.php"
                    className="text-gray-300 hover:text-white transition flex items-center"
                  >
                    <span className="mr-2">→</span> Terms of Service
                  </a>
                </li>
                <li>
                  <a href="./refund_policy.php" className="text-gray-300 hover:text-white transition flex items-center">
                    <span className="mr-2">→</span> Refund Policy
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <div className="relative inline-block mb-4">
                <h3 className="text-xl font-bold">Contact</h3>
                <div className="absolute -bottom-1 left-0 w-1/2 h-0.5 bg-white"></div>
              </div>
              <p className="text-gray-300 mb-4">Have questions or feedback? We're here to help!</p>
              <button
                onClick={() => setShowContactPopup(true)}
                className="px-6 py-2 bg-white text-green-900 rounded-md hover:bg-gray-100 transition transform hover:scale-105"
              >
                Contact Us
              </button>
            
            </div>
          </div>

          <div className="border-t border-white border-opacity-20 mt-12 pt-8 text-center text-gray-300">
            <p>&copy; {new Date().getFullYear()} Aviator. All rights reserved.</p>
            <p className="mt-2">For entertainment purposes only. 18+</p>
            <div className="mt-4 flex justify-center space-x-2">
              <div className="w-3 h-3 bg-red-500 rounded-full"></div>
              <div className="w-3 h-3 bg-white rounded-full"></div>
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default App
